function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BaseUploadNodeProps } from "../typing";
import { signal } from "@preact/signals-react";
export var HtmlBlocState = /*#__PURE__*/_createClass(function HtmlBlocState() {
  _classCallCheck(this, HtmlBlocState);
  _defineProperty(this, "realWidth", signal(false));
  _defineProperty(this, "iframeLoadError", signal(false));
  _defineProperty(this, "historyStack", signal([]));
  _defineProperty(this, "previewStyle", signal({}));
  _defineProperty(this, "props", new BaseUploadNodeProps());
});
export var HtmlBloc = /*#__PURE__*/function () {
  function HtmlBloc() {
    _classCallCheck(this, HtmlBloc);
    _defineProperty(this, "state", new HtmlBlocState());
    this.clickIframe = this.clickIframe.bind(this);
  }
  _createClass(HtmlBloc, [{
    key: "iframeId",
    get: function get() {
      return "iframe-" + this.state.props.id;
    }
  }, {
    key: "setProps",
    value: function setProps(prop) {
      this.state.props = prop;
    }
  }, {
    key: "getIframeDocument",
    value: function getIframeDocument() {
      var iframe = document.getElementById(this.iframeId);
      return iframe.contentDocument || iframe.contentWindow.document;
    }
  }, {
    key: "checkIframeCrossOrigin",
    value: function checkIframeCrossOrigin(iframe) {
      try {
        var _iframe$contentWindow;
        // 尝试访问 iframe 的内容
        iframe.contentDocument || ((_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 ? void 0 : _iframe$contentWindow.document);
        return false; // 没有抛出错误，说明不是跨域
      } catch (e) {
        return true; // 抛出错误，说明是跨域
      }
    }
  }, {
    key: "backHistory",
    value: function backHistory() {
      var iframe = document.getElementById(this.iframeId);
      var lastUrl = this.state.historyStack.value.pop();
      if (!lastUrl) return;
      iframe.src = lastUrl;
      this.state.historyStack.value = [];
    }
  }, {
    key: "checkIfIframeLoadedAndAddListener",
    value: function checkIfIframeLoadedAndAddListener() {
      var _this = this;
      setTimeout(function () {
        var iframeDocument = _this.getIframeDocument();
        iframeDocument.addEventListener("click", _this.clickIframe);
      }, 100);
    }
  }, {
    key: "clickIframe",
    value: function clickIframe(e) {
      var _this2 = this,
        _e$target,
        _e$target2;
      // 处理选中
      if (this.state.props.checkNodeArr.indexOf(this.state.props.id) === -1) {
        this.state.props.setCheckNodeArr([this.state.props.id]);
      } else {
        this.state.props.setCheckNodeArr(this.state.props.checkNodeArr.filter(function (x) {
          return x !== _this2.state.props.id;
        }));
      }

      // 处理点击a标签的跳转
      if (((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.tagName) === "A" && (_e$target2 = e.target) !== null && _e$target2 !== void 0 && _e$target2.href) {
        var _this$state$props$cre;
        this.state.historyStack.value.push(((_this$state$props$cre = this.state.props.createBlobUrl) === null || _this$state$props$cre === void 0 ? void 0 : _this$state$props$cre.objectURL) || "");
        // 跳转新链接后移除点击事件监听
        var iframeDocument = this.getIframeDocument();
        iframeDocument.removeEventListener("click", this.clickIframe);
      }
    }
  }]);
  return HtmlBloc;
}();